export function getCurrentStep(state) {
	return state.step;
}

export function getStepsCount(state) {
	return state.stepsCount;
}

export function getFormIsDirty(state) {
	return state.dirty;
}

export function getFormIsBeingSubmitted(state) {
	return state.loading;
}

export function getFormIsSubmitted(state) {
	return state.success;
}

export function getFormHasError(state) {
	return state.error;
}

export function getRedirectAllowed(state) {
	return state.redirect;
}

export function getUserExists(state) {
	return state.userExists;
}
